import { Pipe, PipeTransform } from "@angular/core";

import { MedTableColumnConfig } from "../types";
import { MedTableSettingsLocal } from "../types.local";

@Pipe({
  name: "getCellMinWidth",
})
export class GetCellMinWidthPipe implements PipeTransform {
  transform({ minWidth }: MedTableColumnConfig, settingsLocal: MedTableSettingsLocal): string {
    return minWidth || settingsLocal.colMinWidth;
  }
}
